export enum TeamStatusEnum {
  REGISTERED = 'REGISTERED',
  REJECTED = 'REJECTED',
  WAIT_VALIDATE = 'WAIT_VALIDATE',
  WAIT_VALIDATE_PLAYERS = 'WAIT_VALIDATE_PLAYERS',
  VALID = 'VALID',
}
